import logo from "../objects/logo.png"
import NavBarMolor from "./NavbarMolor";

function Header() {
    return (
        <>
            <header className="d-flex justify-content-between align-items-md-center pb-3  ">
                <h1 className="h4">
                    <a
                        href="/"
                        className="d-flex align-items-center text-dark text-decoration-none"
                    >
                        <img src={logo} width={80} alt={"logo"}/>
                        <span style={{ "marginLeft": 10 }}> Morphologically Linked Old Irish Resource</span>
                    </a>
                </h1>
                <a
                    href="https://github.com/CIRCSE/Molor"
                    target="_blank"
                    rel="noopener"
                >
                    View on GitHub
                </a>

            </header>
            <div className="d-flex justify-content-between align-items-md-center pb-3 mb-5 border-bottom">
                <NavBarMolor />
            </div>
        </>
    );
}

export default Header;